import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as ScenarioAPI from '../../../services/ScenarioServices';
import { createCanvas } from '../../../services/CanvasServices';
import styles from './styles/CreateScenarioModal.module.css';
import PermissionsContext from '../../../context/PermissionsContext';
import {
    TUTORIAL_TARGETS,
    tutorialAttr,
    tutorialBus,
    useTutorial,
} from '../../../tutorials';

const CreateScenarioModal = ({ isOpen, onClose }) => {
    const { setScenarioCount } = useContext(PermissionsContext)
    const [title, setTitle] = useState('');
    const [creating, setCreating] = useState(false);
    const navigate = useNavigate();

    // During the tutorial the title is decided for the user, so the first step
    // is about pressing Create rather than about inventing a name.
    const { isLocked, tutorial } = useTutorial();
    const locked = isLocked('createModal');
    const lockedTitle = tutorial?.content?.scenario?.title || '';

    useEffect(() => {
        if (locked && lockedTitle) setTitle(lockedTitle);
    }, [locked, lockedTitle]);

    if (!isOpen) return null;

    const handleCreate = async () => {
        if (creating) return;
        setCreating(true);
        try {

            const scenarioData = await ScenarioAPI.createScenario(title);
            const scenarioId = scenarioData._id;


            await createCanvas(scenarioId);

            // Awaited, not fired and forgotten: a running tutorial fills in the
            // description and tags here, and the settings page is about to load
            // and would otherwise render before those landed.
            await tutorialBus.emitAsync('scenario:created', { scenarioId });


            navigate(`/create/${scenarioId}`);
            setScenarioCount(prev => prev+1);

            onClose();
            setTitle('');
        } catch (err) {
            console.error("Error creating scenario or canvas:", err);
        } finally {
            setCreating(false);
        }
    };

    const handleCancel = () => {
        onClose();
        setTitle('');
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <h2>Create New Scenario</h2>
                <input
                    type="text"
                    placeholder="Scenario Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className={styles.inputField}
                    readOnly={locked}
                    {...tutorialAttr(TUTORIAL_TARGETS.CREATE_MODAL_TITLE)}
                />
                <div className={styles.buttonRow}>
                    <button
                        onClick={handleCreate}
                        className={styles.createButton}
                        disabled={creating}
                        {...tutorialAttr(TUTORIAL_TARGETS.CREATE_MODAL_CREATE_BUTTON)}
                    >
                        <span className={styles.plusSign}>+</span> Create
                    </button>
                    <button onClick={handleCancel} className={styles.cancelButton} disabled={locked}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateScenarioModal;
